import { Dropdown } from "react-bootstrap";
import { FaCircle } from "react-icons/fa";
import navdots from '../../../Assets/images/navdots.svg';
import { useState } from "react";
import ConfirmationModal from "../../ConfirmationModal";
import StudyTitleCell from "./StudyTitleCell";

function ParentStudiesTableRow({ study, handleUpdateStatus, onEditStudy }) {
    
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const confirmDeleteUser = () => {
        confirmDelete();
        handleCloseDeleteModal();
    };

    const confirmDelete = () => {
        handleUpdateStatus(study.id, 2); 
    };

    const toggleStatus = () => {
        const newStatus = study.status === '1' ? 0 : 1;
        handleUpdateStatus(study.id, newStatus);
    };


    return (<>
        <tr>
            <td>
                {new Date(study.created_at).getTime() === 0
                    ? "-"
                    : new Date(study.created_at).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    })}
            </td>
            {/* <td
                title={study.title}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
            >
                {study.title.length > 25
                    ? study.title.substring(0, 25) + "..."
                    : study.title}
            </td> */}
            <StudyTitleCell title={study.title} />
            <td>{study.no_of_projects}</td>
            <td>{study.user_id}</td>
            <td>
                <span className={`d-flex align-items-center ${study.status === '0' ? "li-sl-blue" : study.status === '1' ? "text-success" : ""}`}><FaCircle className=" fa-dot me-2 mb-1" />{study.status === '1' ? 'Active' : 'Pause'}</span></td>
            <td>
                <div className="dropdown">
                    <Dropdown>
                        <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                            <img src={navdots} alt="More actions" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="el-action">
                            {/* onClick={handleEditDonor}  */}

                            <Dropdown.Item onClick={() => onEditStudy(study)}>
                                <label>Edit</label>
                            </Dropdown.Item>
                            <Dropdown.Item  onClick={toggleStatus}>
                                <label>{study.status === '1' ? 'Pause' : 'Activate'}</label>
                            </Dropdown.Item>
                            <Dropdown.Item   onClick={handleShowDeleteModal}>
                                <label className="text-danger">Delete</label>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </td>
        </tr>
        {/* Delete sample request  */}
        <ConfirmationModal
            show={showDeleteModal}
            onHide={handleCloseDeleteModal}
            onConfirm={confirmDeleteUser}
            title=""
            body={`Are you sure you want to delete?`}
            
        />
    </>)
}
export default ParentStudiesTableRow;